import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

// ── Brand tokens (matched from cubeangle.com) ─────────────────────────────────
const CORAL = '#E8605E';       // coral/red-orange — logo + hero swirl accent
const CORAL_DARK = '#C94B49';  // hover / pressed state
const PAGE_BG = '#12121E';     // deep navy-black — website hero background
const SURFACE = '#1A1A2E';     // slightly lighter — sidebar, cards
const BORDER = '#2A2A44';      // subtle dividers

// Page-header gradient: mirrors the dark→coral sweep in the website hero
const HEADER_GRADIENT: [string, string] = [PAGE_BG, CORAL];

export const cubeAngleTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    mode: 'dark',
    primary: {
      main: CORAL,
      dark: CORAL_DARK,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: CORAL,
      dark: CORAL_DARK,
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#CF6679',
    },
    warning: {
      main: '#F57C00',
    },
    success: {
      main: '#4CAF50',
    },
    info: {
      main: '#64B5F6',
    },
    background: {
      default: PAGE_BG,
      paper: SURFACE,
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#AAAACC',
    },
    divider: BORDER,
    // ── Backstage-specific: sidebar ──────────────────────────────────────────
    navigation: {
      background: SURFACE,
      indicator: CORAL,
      color: '#CCCCDD',
      selectedColor: '#FFFFFF',
      navItem: {
        hoverBackground: '#25253E',
      },
      submenu: {
        background: PAGE_BG,
      },
    },
    // ── Backstage-specific: status chips ─────────────────────────────────────
    status: {
      ok: '#4CAF50',
      warning: '#F57C00',
      error: '#CF6679',
      running: CORAL,
      pending: '#7E57C2',
      aborted: '#757575',
    },
    // ── Backstage-specific: gold / link ──────────────────────────────────────
    gold: CORAL,
    link: CORAL,
    linkHover: CORAL_DARK,
  } as any,

  fontFamily: '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',

  defaultPageTheme: 'home',

  pageTheme: {
    home:          genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    catalog:       genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    documentation: genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    tool:          genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    service:       genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    website:       genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    library:       genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    other:         genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    app:           genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    apis:          genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    component:     genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    resource:      genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    system:        genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    domain:        genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    group:         genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    user:          genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
    template:      genPageTheme({ colors: HEADER_GRADIENT, shape: shapes.wave }),
  },
});
